import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-center" }
const _hoisted_2 = { class: "p-inputgroup" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Nessuna modifica rispetto alle tipologie configurati nella "),
  /*#__PURE__*/_createElementVNode("strong", null, "zona")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VehicleAutocomplete = _resolveComponent("VehicleAutocomplete")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_VehicleAutocomplete, {
          ids: _ctx.selectedVehicleIds,
          onSelect: _ctx.onSelect
        }, null, 8, ["ids", "onSelect"])
      ])
    ]),
    (!_ctx.hasVehicles)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          closable: false
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "message", {}, () => [
              _hoisted_4
            ])
          ]),
          _: 3
        }))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          value: _ctx.vehicles,
          class: "p-mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "vehicle.name_it",
              header: "Nome tipologia"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", null, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`p-mr-2 fas fa-${data.vehicle.icon}`)
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(data.vehicle.name_it), 1)
                ])
              ]),
              _: 1
            }),
            (_ctx.showPrice)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  field: "extra_price",
                  header: "Prezzo extra"
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_FloatLabel, { label: "Prezzo extra" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputNumber, {
                          modelValue: data.extra_price,
                          "onUpdate:modelValue": ($event: any) => (data.extra_price = $event),
                          mode: "currency",
                          currency: "EUR"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showCost)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 1,
                  field: "extra_cost",
                  header: "Costo extra"
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_FloatLabel, { label: "Costo extra" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputNumber, {
                          modelValue: data.extra_cost,
                          "onUpdate:modelValue": ($event: any) => (data.extra_cost = $event),
                          mode: "currency",
                          currency: "EUR"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Column, {
              field: "is_enabled",
              header: "Attivo"
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_InputSwitch, {
                  class: "p-mr-3",
                  modelValue: data.is_enabled,
                  "onUpdate:modelValue": ($event: any) => (data.is_enabled = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { class: "column-header-right p-text-right" }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_DeleteButton, {
                  onClick: ($event: any) => (_ctx.removeVehicle(data)),
                  title: "rimuovi tipologia"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
  ]))
}